var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Controls_icon_Clock",
    "data-name": "Controls/icon/Clock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2318",
    "data-name": "Rectangle 2318",
    width: 38,
    height: 38,
    fill: "none",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2897",
    "data-name": "Group 2897",
    transform: "translate(1 0.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3772",
    "data-name": "Path 3772",
    d: "M32.61,14.517a18,18,0,1,0,18,18A18.021,18.021,0,0,0,32.61,14.517Zm11.243,28-1-1a.879.879,0,1,0-1.243,1.243l1,1a14.993,14.993,0,0,1-9.122,3.783V46.127a.879.879,0,0,0-1.757,0v1.416a14.987,14.987,0,0,1-9.122-3.783l1-1a.879.879,0,0,0-1.243-1.243l-1,1A14.994,14.994,0,0,1,17.583,33.4H19a.879.879,0,0,0,0-1.757H17.583a15,15,0,0,1,3.784-9.124l1,1a.878.878,0,1,0,1.243-1.242l-1-1a14.987,14.987,0,0,1,9.122-3.783v1.416a.879.879,0,0,0,1.757,0V17.49a14.993,14.993,0,0,1,9.122,3.783l-1,1a.878.878,0,1,0,1.243,1.242l1-1a14.982,14.982,0,0,1,3.784,9.122H46.22a.879.879,0,0,0,0,1.757h1.416A14.985,14.985,0,0,1,43.853,42.518Z",
    transform: "translate(-14.61 -14.517)",
    fill: "#75787b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3773",
    "data-name": "Path 3773",
    d: "M40.608,30.029H31.349l-5.758-5.774A.879.879,0,0,0,24.347,25.5l6.014,6.031c.007.007.015.008.022.015a.855.855,0,0,0,.264.175.887.887,0,0,0,.337.069h9.624a.879.879,0,1,0,0-1.757Z",
    transform: "translate(-12.984 -12.891)",
    fill: "#75787b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.2b15c2c35651f463a5b5fc18b2a8de41.svg";
export { ForwardRef as ReactComponent };